import { PercentageCell } from 'shared/ui/Table';
import { TotalTooltipContent } from 'shared/ui/Table/Components/PercentageCell/TotalTooltipContent';

interface PercentageCellWithBadgeProps {
  className?: string;
  total: string;
  title: string;
  budget: string;
  refund: string;
  isFormatToCents?: boolean;
  percent?: string | number;
  onClick?: () => void;
  isPercentageTooltipStatus?: boolean;
  percentageBadgeTooltipContent?: string | JSX.Element;
}

export function PercentageCellConfigured({
  className,
  total,
  title,
  percent,
  onClick,
  isPercentageTooltipStatus,
  percentageBadgeTooltipContent,
  isFormatToCents,
  refund,
  budget,
}: PercentageCellWithBadgeProps) {
  const isBadge = Number(percent) >= 80;
  const shouldShowPercentageTooltip = isPercentageTooltipStatus && isBadge;

  const isRefund = Number(refund) > 0;

  return (
    <PercentageCell
      onClick={onClick}
      className={className}
      title={title}
      percent={percent}
      total={total}
      isMoney
      isPercentageBadge={isBadge}
      isPercentageBadgeTooltip={shouldShowPercentageTooltip}
      percentageBadgeTooltipContent={percentageBadgeTooltipContent}
      percentageTooltipClass="!max-w-[249px] !pr-2"
      isTotalBadge={isRefund}
      isTotalBadgeTooltip={isRefund}
      isFormatToCents={isFormatToCents}
      totalBadgeTooltipContent={
        <TotalTooltipContent
          budget={budget}
          refund={refund}
        />
      }
    />
  );
}
